import styled from 'styled-components'

export const AvatarWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover .avatar-overlay {
    opacity: 1;
  }
`

export const AvatarOverlay = styled.div.attrs({ className: 'avatar-overlay' })`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  color: #fff;
  font-size: 18px;
`

export const HiddenInput = styled.input.attrs({
  type: 'file',
  accept: 'image/*',
})`
  display: none;
`
